import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import PublicRoute from "../routes/PublicRoute";
import ProtectedLayout from "../routes/ProtectedLayout";
import { ForgotOtp } from "../pages/Auth/ForgotOtp";
import ForgetPassword from "../pages/Auth/ForgetPassword";
import UpdatePassword from "../pages/Auth/UpdatePassword";
import Login from "../pages/Auth/Login";
import Signup from "../pages/Auth/Signup";
import { OTP } from "../pages/Auth/OTP";
import Password from "../pages/Auth/Password";
import Wallet from "../pages/User/Wallet";
import Withdraw from "../components/Withdraw";
import MyProfile from "../components/ProfileSettings";
import UserProfile from "../pages/User/UserProfile";
import EditProfile from "../pages/User/EditProfile";
import Posts from "../components/Posts";
import Savedposts from "../components/Savedposts";
import Message from "../pages/User/Message";
import Kyc2 from "../pages/User/Kyc2";
import Kyc3 from "../pages/User/Kyc3";
import Kyc from "../pages/User/Kyc";
import Aadhaar from "../pages/User/Aadhaar";
import Verified from "../components/Verified";
import Prime from "../pages/User/Prime";
import Supportpage from "../pages/User/Supportpage";
import Revolution from "../components/Revolution";
import MyRevolution from "../pages/User/MyRevolution";
import AllRevolution from "../pages/User/AllRevolution";
import CreateRevolution from "../pages/User/CreateRevolution";
import BlockedList from "../pages/User/BlockedList";
import Donation from "../pages/Donation";
import SharedPost from "../pages/User/SharedPost";
import SharedRevolution from "../pages/User/SharedRevolution";
import NotificationPost from "../pages/User/NotificationPost";
import QRCodePoup from "../components/model/QRCodePopup";
import RevolutionEmail from "../components/model/RevolutionEmail";
import DonationSuccess from "../pages/DonationSuccess";
import Certificate from "../pages/Certificate";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Terms from "../pages/Term";
import DeActiveProfile from "../pages/DeActiveProfile";
import DeleteAccount from "../pages/User/DeleteAccount";
import DeleteAccountRequest from "../pages/User/DeleteAccountRequest";
import DeletionRequestSuccess from "../pages/User/DeletionRequestSuccess";

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/delete-account-request"
          element={<DeleteAccountRequest />}
        />
        <Route
          path="/deletion-request-success"
          element={<DeletionRequestSuccess />}
        />

        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/OTP" element={<OTP />} />
          <Route path="/password" element={<Password />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/forget-otp" element={<ForgotOtp />} />
          <Route path="/reset-password" element={<UpdatePassword />} />
        </Route>

        {/* -------- PROTECTED ROUTES -------- */}
        <Route element={<ProtectedLayout />}>
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/my/:userId/profile" element={<MyProfile />} />
          <Route path="/user/:userId/profile" element={<UserProfile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/deactive-profile" element={<DeActiveProfile />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          {/* <Route path="/certificate" element={<Certificate/>} /> */}
          <Route path="/kyc" element={<Kyc />} />
          <Route path="/aadhaar-verification" element={<Aadhaar />} />
          <Route path="/donation" element={<Donation />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="/blocked-user" element={<BlockedList />} />
          <Route path="/kyc2" element={<Kyc2 />} />
          <Route path="/kyc3" element={<Kyc3 />} />
          <Route path="/savedposts" element={<Savedposts />} />
          <Route path="/verified" element={<Verified />} />
          <Route path="/message" element={<Message />} />
          <Route path="/message/:userId" element={<Message />} />
          <Route path="/feed" element={<Navigate to="/feed/prime" replace />} />
          <Route path="/feed/:type" element={<Prime />} />
          <Route path="/post/:postId" element={<SharedPost />} />
          <Route path="/support-chat" element={<Supportpage />} />
          <Route path="/revolution" element={<Revolution />} />
          <Route path="/revolution/my" element={<MyRevolution />} />
          <Route path="/revolution/all" element={<AllRevolution />} />
          <Route path="/revolution/create" element={<CreateRevolution />} />
          <Route path="/p/:postId" element={<NotificationPost />} />
          <Route path="/r/:revolutionId" element={<SharedRevolution />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default AppRoutes;
